<template>
    <div class="establishment-add-modal">
        <el-dialog title="Ajouter un établissement" :visible.sync="innerVisible" size="small" :close-on-click-modal="false">
            <ck-form ref='add-establishment' label-position="top">
                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Etablissement" :display="establishment.EstablishmentName">
                            <el-input v-model="establishment.EstablishmentName" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: establishment.EstablishmentName, trigger: 'change' }">
                                Veuillez indiquer le nom de l'établissement partenaire
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Type d'établissement" :display="establishment.Type">
                            <el-input v-model="establishment.Type" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Statut de l'établissement" :display="establishment.Status">
                            <el-input v-model="establishment.Status" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Numéro de SIREN" :display="establishment.SIREN">
                            <el-input v-model="establishment.SIREN" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Numéro de SIRET" :display="establishment.SIRET">
                            <el-input v-model="establishment.SIRET" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Addresse" :display="establishment.Address">
                            <el-input v-model="establishment.Address" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Complément d'adresse" :display="establishment.AddressComp">
                            <el-input v-model="establishment.AddressComp" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Code postal" :display="establishment.ZipCode">
                            <el-input v-model="establishment.ZipCode" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Ville" :display="establishment.City">
                            <el-input v-model="establishment.City" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Information de contact" :display="establishment.ContactInformations">
                            <el-input v-model="establishment.ContactInformations" auto-complete="off" type="textarea" autosize></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
                
                <div>
                    <div class="pull-right">
                        <el-button type="default" @click="cancelAdd">Annuler</el-button>
                        <el-button type="primary" @click="endAdd" native-type="submit">Enregistrer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('add-establishment-modal', {
    model: {
        prop: 'establishment',
        event: 'change'
    },
    props: {
        postUrl: String,
        visible: Boolean
    },
    data() {
        return {
            establishment: {
                EstablishmentName: ''
            },
            innerVisible: false
        }
    },
    mounted: function() {
    },
    methods: {
        reset() {
            this.establishment = {
                EstablishmentName: ''
            };
        },
        cancelAdd() {
            this.innerVisible = false;
            this.reset();
        },
        endAdd(e) {
            e.preventDefault();
            this.$refs['add-establishment'].validate((valid) => {
                if (valid) {
                    this.$http.post(this.postUrl, this.establishment).then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Enregistré',
                            text: 'L\'établissement a bien été ajouté'
                        }).then(() => {

                        });

                        //reset form
                        this.cancelAdd();

                        this.$root.$emit('pcr_update_data');
                        this.$root.$emit('pcr_update_tree');
                    });
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        }
    },
    watch: {
        innerVisible(val) {
            if(this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            this.innerVisible = val;
            if(!val) {
                this.reset();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/add-establishment-modal.vue